import Api from '@api/cardCoupon'
import { observable, runInAction, action } from 'mobx'
import { dGet } from '@core/utils'

class Store {
  @observable visible = false
  @observable successVisible = false // 领取成功 modal
  @observable successMsg = '' // 领取成功文字
  @observable poster = {}

  getCouponPoster = async () => {
    const { data } = await Api.couponPoster()

    runInAction(() => {
      const holes = dGet(data, 'floors.SERVICE_WEB_MERCHANT_COUPON.holes', [])
      holes.forEach(hole => {
        if (hole.posters) {
          this.poster = hole.posters
          this.visible = true
        }
      })
    })
  }

  getCoupon = async () => {
    const {
      success,
      data: { msg: successMsg }
    } = await Api.exchangeCoupon({
      merchant_coupon_id: this.poster.target_id
    })

    if (success) {
      this.visible = false

      this.successMsg = successMsg
      this.successVisible = true
    }
  }

  @action
  closePopup = () => {
    this.visible = false
  }

  @action
  cancelSuccessModal = () => {
    this.successMsg = ''
    this.successVisible = false
  }
}

export default Store
